var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconSellerNavbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75087 4.94444C5.75087 3.7657 6.21912 2.63524 7.05262 1.80175C7.88611 0.968252 9.01657 0.5 10.1953 0.5C11.3741 0.5 12.5045 0.968252 13.338 1.80175C14.1715 2.63524 14.6398 3.7657 14.6398 4.94444C14.6398 6.12318 14.1715 7.25365 13.338 8.08714C12.5045 8.92064 11.3741 9.38889 10.1953 9.38889C9.01657 9.38889 7.88611 8.92064 7.05262 8.08714C6.21912 7.25365 5.75087 6.12318 5.75087 4.94444ZM5.75087 11.6111C4.27744 11.6111 2.86437 12.1964 1.8225 13.2383C0.780628 14.2802 0.195313 15.6932 0.195312 17.1667C0.195313 18.0507 0.546502 18.8986 1.17162 19.5237C1.79674 20.1488 2.64459 20.5 3.52865 20.5H16.862C17.746 20.5 18.5939 20.1488 19.219 19.5237C19.8441 18.8986 20.1953 18.0507 20.1953 17.1667C20.1953 15.6932 19.61 14.2802 18.5681 13.2383C17.5263 12.1964 16.1132 11.6111 14.6398 11.6111H5.75087Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSellerNavbar);
export default __webpack_public_path__ + "static/media/ProfileIcon_SellerNavbar.2f414044f4e0dbacaf41354d40099f9b.svg";
export { ForwardRef as ReactComponent };